export default __webpack_public_path__ + "static/media/genuine-additional.00712a89.png";